import React, { Component } from 'react';
import { array, func, object } from 'prop-types';
import Cell from 'ps-components/Table/Cell/Cell';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import Row from 'ps-components/Table/Row/Row';

import './SkillRow.scss';

class SkillRow extends Component {
  static propTypes = {
    toggleSkill: func,
    selectedSkills: array,
    skill: object
  };

  isSkillSelected = () => {
    const { selectedSkills, skill } = this.props;

    return selectedSkills.includes(skill.skill);
  };

  toggleSkill = () => {
    const { skill, toggleSkill } = this.props;

    toggleSkill(skill);
  };

  render() {
    const { skill } = this.props;
    const percentReporting = skill.percentReporting.toFixed(1);
    const skillDifferential = skill.payDifferentialPercentage.toFixed(1);

    return (
      <Row className="skill__table-row" key={skill.skill}>
        <Cell>
          <CheckboxInput checked={this.isSkillSelected()} disabled={false} onClick={this.toggleSkill} />
        </Cell>
        <Cell>{skill.skill}</Cell>
        <Cell>{`${percentReporting}%`}</Cell>
        <Cell>{skillDifferential > 0 ? `+${skillDifferential}%` : `${skillDifferential}%`}</Cell>
      </Row>
    );
  }
}

export default SkillRow;
